import EuRailRailcardsModal from './eurail-railcards-modal-component';
import EuRailRailcardsModalService from './eurail-railcards-modal-service';

const MODULE_NAME = 'app.eurail.railcards-modal';
const module = angular.module(MODULE_NAME, [])
    .directive(EuRailRailcardsModal.DIRECTIVE_NAME, EuRailRailcardsModal)
    .service('euRailRailcardsModalService', EuRailRailcardsModalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-railcards-modal/eurail-railcards-modal-module.js